import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/reset.css";
import "./index.css";
import { AppProviders } from "./app/providers/AppProviders";
import { AppRoutes } from "./app/routes/AppRoutes";

function removeInjectedRefineDevtools() {
  const selectors = [
    "[id*='refine-devtools']",
    "[class*='refine-devtools']",
    "[data-testid*='refine-devtools']",
    "[aria-label*='Refine Devtools']"
  ];

  for (const selector of selectors) {
    document.querySelectorAll(selector).forEach((node) => {
      (node as HTMLElement).style.display = "none";
      (node as HTMLElement).style.visibility = "hidden";
    });
  }

  // Some browser extensions inject generic containers with text content only.
  document.querySelectorAll("body *").forEach((node) => {
    if (!(node instanceof HTMLElement)) return;
    const text = (node.textContent ?? "").toLowerCase();
    if (text.includes("refine devtools") || text.includes("devtoolsprovider")) {
      node.style.display = "none";
      node.style.visibility = "hidden";
    }
  });
}

removeInjectedRefineDevtools();
setInterval(removeInjectedRefineDevtools, 1200);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppProviders>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AppRoutes />
      </BrowserRouter>
    </AppProviders>
  </React.StrictMode>
);
